import { NUMERIC_ORDER_FIELDS } from '../consts/numericOrderFields.js'

// Возвращает копию payload с числовыми полями, приведёнными к number.
// Остальные поля не трогаем.
export function normalizeNumericFields(payload) {
  if (!payload || typeof payload !== 'object') return payload
  const next = { ...payload }
  for (const field of NUMERIC_ORDER_FIELDS) {
    if (field in next) next[field] = parseFloat(next[field])
  }
  return next
}
